export default __webpack_public_path__ + "static/media/caderas.1c8a5830.png";